// extracted by mini-css-extract-plugin
module.exports = {"container":"card_container__3G4Fa","card":"card_card__1py-W","name":"card_name__31aE7","actions":"card_actions__31KML","left":"card_left__kmFAA","right":"card_right__ikHyB"};